export default __webpack_public_path__ + "static/media/auth_graphic.3ce610b2.png";